module.exports = __webpack_public_path__ + "static/tande-278df92b794b1a597fd2c44ec8b9924f.webp";